import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { OrderService } from 'src/app/shared/services/order-service';
import { Payment } from 'src/app/shared/models/order';
import * as _ from "lodash";
import { SendOrderService } from 'src/app/shared/services/send-order';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { take, catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs';
@Component({
  selector: 'app-billing-information',
  templateUrl: './billing-information.component.html',
  styleUrls: ['./billing-information.component.scss']
})
export class BillingInformationComponent implements OnInit {

  constructor(private orderSerrvice: OrderService, private orderService: OrderService, private sendOrderService: SendOrderService, private spinnerService: SpinnerService) { }
  monthes: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  years: number[] = [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027];
  @Output() stepConfirm = new EventEmitter<number>();
  @Output() finishCheckOut = new EventEmitter<boolean>();
  month;
  year;
  cardNumber;
  cvv;
  selectedYear;
  paymentType;
  name;
  error: string;
  ngOnInit(): void {
    this.paymentType = 1;
   }
  async confirm() {
    if (!this.formValid()) {
      return;
    }
    const payment: Payment = {
      paymentType: this.paymentType,
      cardNumber: this.cardNumber,
      cardName: this.name,
      month: this.month,
      year: this.year,
      cvv: this.cvv,
    };
    this.orderSerrvice.setOrder({ payment: payment })
    const order = this.orderSerrvice.getOrderObject();
    await this.sendOrder(order)
  }
  back() {
    this.stepConfirm.emit(-1);
  }
  newPayment(event) {
    if (event == "אשראי") {
      this.paymentType = 1;
    }
    if (event == "מזומן") {
      this.paymentType = 2;
    }
    if (event == "תן ביס") {
      this.paymentType = 12;
    }
    if (event == "סיבוס") {
      this.paymentType = 10;
    }
  }

  formValid(): boolean {
    this.error = null;
    if (this.paymentType===2){
      return true;
    }
    if (_.isNil(this.paymentType)) {
      this.error = "אנא הזן סוג תשלום";
      return false;
    }
    if (_.isNil(this.cardNumber)) {
      this.error = "אנא הזן מספר כרטיס";
      return false;
    }
    if (_.isNil(this.name)) {
      this.error = "אנא הזן שם בעל הכרטיס";
      return false;
    }
    if (this.paymentType === 1) {
      if(!this.validateCreditCardNumber(this.cardNumber)){
        this.error = "מספר כרטיס לא תקין";
        return false;
      }
      if (_.isNil(this.month) || _.isNil(this.year)) {
        this.error = "אנא הזן תוקף";
        return false;
      }
      if (_.isNil(this.cvv)) {
        this.error = "אנא הזן cvv";
        return false;
      }
    }
    return true;
  }
  public async sendOrder(order: any) {
    this.spinnerService.show();
    this.sendOrderService
      .pushOrder(order)
      .pipe(
        take(1),
        catchError((err) => {
          console.log("sendOrder err", err)
          return of(err);
        }),
        finalize(() => {
          this.spinnerService.hide();
        })
      )
      .subscribe((res: any) => {
        console.log("sendOrder", res);
        if (res.error || _.isNil(res)){
          this.error=res.error;
          return;
        }
        this.orderSerrvice.setOrder({ "response": res });
        this.stepConfirm.emit(1);
        // if (res["result"]===true)
        // {
        //   this.toastrService.success("הזמנה נקלטה בהצלחה", "מספר הזמנה: " + res["orderCenterId"]);
        //   this.orderService.removeOrder()
        //   this.router.navigate([""]);
        // }
        // if (res["result"]===false)
        // {
        //   this.toastrService.error("הזמנה נכשלה","אנא נסה בשנית");
        // }
      });
  }
  validateCreditCardNumber(value: string):boolean {
    if (/[^0-9-\s]+/.test(value)) return false;
    var nCheck = 0,
      nDigit = 0,
      bEven = false;
    value = value.replace(/\D/g, "");

    for (var n = value.length - 1; n >= 0; n--) {
      var cDigit = value.charAt(n),
        nDigit = parseInt(cDigit, 10);

      if (bEven) {
        if ((nDigit *= 2) > 9) nDigit -= 9;
      }

      nCheck += nDigit;
      bEven = !bEven;
    }

    return nCheck % 10 == 0;
  }
}
